import "../../assets/css/Login/Login.css";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { loginRequest } from "../../Auth/Config";
import api from "../../api/axios";
import logo from "../../assets/images/logo.webp";
import { fetchMicrosoftPhoto } from "../../utils/msalPhoto";
const Login = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    const token = sessionStorage.getItem("crm_token");
    if (token) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const handleMicrosoftLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest);

      instance.setActiveAccount(loginResponse.account);

      const tokenResponse = await instance.acquireTokenSilent({
        ...loginRequest,
        account: loginResponse.account,
      });

      const microsoftToken = tokenResponse.accessToken;

      const res = await api.post("/auth/microsoft-login", {
        microsoft_token: microsoftToken,
      });


      console.log("Backend response:", res.data);

      // Optional: If you need to send directly to live backend instead of configured api instance, uncomment below:
      /*
      const apiResponse = await fetch(
        "https://testcrm.ssdneducation.com/api/auth/microsoft-login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            microsoft_token: microsoftToken,
          }),
        }
      );
      */


      const appToken = res.data.access_token || res.data.token;
      const refreshToken = res.data.refresh_token;

      if (!appToken) {
        throw new Error("Token not returned from backend");
      }

      sessionStorage.setItem("crm_token", appToken);
      if (refreshToken) {
        sessionStorage.setItem("crm_refresh_token", refreshToken);
      }
      sessionStorage.setItem("user", JSON.stringify(res.data.user));

      // Fetch Microsoft profile photo via Graph API and cache in session
      try {
        const photoData = await fetchMicrosoftPhoto(instance, loginResponse.account);
        if (photoData) {
          sessionStorage.setItem("user_photo", photoData);
        }
      } catch (photoErr) {
        console.debug("Could not cache Microsoft photo at login:", photoErr);
      }

      navigate("/", { replace: true });

    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
          <img src={logo} alt="Company Logo" className="company-logo" />
        <div className="logo">CRM Portal</div>

        <h1>Welcome</h1>
        <p>Sign in with your Microsoft account</p>

        <button className="microsoft-btn" onClick={handleMicrosoftLogin}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="Microsoft"
          />
          Continue with Microsoft
        </button>
      </div>
    </div>
  );
};

export default Login;